import { useFetchedFilter, useFilterCustomizations, useFilterValues } from 'libs/searchspring/components/collection/filters/FilterHooks'
import Icon from '@/components/snippets/icon/icon'

export function FilterButton({ filter, activeFilters, fetchedFilters, onClick }) {
  if (!filter) return null

  const fetchedFilter = useFetchedFilter(filter, fetchedFilters)
  const filterCustomizations = useFilterCustomizations(filter.field)
  const values = useFilterValues(filter, activeFilters, fetchedFilter, filterCustomizations)
  const label = filter.label
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  const activeCount = values?.filter((item) => item.checked)?.length || 0

  return (
    <button
      className="flex items-center justify-center gap-x-0.625 h-full px-2 border-r border-neutral-light link-fade"
      data-modal-parent={`filter-${id}`}
      data-modal-role="open"
      aria-label={label}
      onClick={onClick}
    >
      <span className="text-s font-bold">
        {label}
        {activeCount > 0 && (
          <>
            &nbsp;({activeCount})
          </>
        )}
      </span>
      <div className={'flex size-[13px] children:size-full'}>
        <Icon id="plus" />
      </div>
    </button>
  )
}
